import React, { useEffect } from "react";
import "./thanks.css";

const Thanks = () => {
  useEffect(() => {
    const confettiContainer = document.querySelector(".confetti-container");

    // Génération des confettis
    for (let i = 0; i < 60; i++) {
      const confetti = document.createElement("div");
      confetti.classList.add("confetti");
      confetti.style.left = `${Math.random() * 100}%`;
      confetti.style.backgroundColor = [
        "#f1debd",
        "#d9c2d3",
        "#f1debd",
        "#d9c2d3",
      ][Math.floor(Math.random() * 4)];
      confetti.style.animationDelay = `${Math.random() * 5}s`;
      confettiContainer.appendChild(confetti);
    }
  }, []);

  return (
    <div className="thanks-page">
      <div className="confetti-container"></div>
      <header>
        <div className="test"></div>
      </header>
      <div className="thanks-message">
        <h1>
          Merci pour <br></br>votre participation à l'atelier !
        </h1>
      </div>
      <footer>
        <div className="links">
          <li>
            <ul>
              <a href="https://www.instagram.com/lacuveeludique/">
                @lacuveeludique
              </a>
            </ul>
            <ul>
              <a href="https://www.lacuveeludique.fr">www.lacuveeludique.fr</a>
            </ul>
            <ul>
              <a href="https://share.google/w8AxNAExMNkALSfF7">
                Retrouvez-moi sur Google !
              </a>
            </ul>
          </li>
        </div>
      </footer>
    </div>
  );
};

export default Thanks;
